import React, { useState } from 'react'
import info_logo from '../Assets/Icons/info.png'

function InfoButton({content}) {
  const [showTooltip, setShowTooltip] = useState(false);

  const toggleTooltip = () => {
    setShowTooltip(!showTooltip);
  };

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <a 
        onClick={toggleTooltip}
        style={{ cursor: 'pointer' }}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleTooltip();
          }
        }}
      >
        <img src={info_logo} alt="tooltip" className="info-button-icon" />
      </a>
      
      {showTooltip && (
        <div 
          style={{
            position: 'absolute',
            bottom: '50%',
            left: '-300%',
            transform: 'translateX(-50%)',
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
            color: 'white',
            padding: '8px 12px',
            borderRadius: '10px',
            fontSize: '12px',
            whiteSpace: 'wrap',
            width:'200px',
            height:'50px',
            display:'flex',
            justifyContent:'center',
            alignItems:'center',
            zIndex: 1000,
            marginBottom: '5px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {content}
          <div 
            style={{
              position: 'absolute',
              top: '100%',
              left: '50%',
              transform: 'translateX(-50%)',
              width: 0,
              height: 0,
              borderLeft: '5px solid transparent',
              borderRight: '5px solid transparent',
              borderTop: '5px solid #333'
            }}
          />
        </div>
      )}
      
      {showTooltip && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 999
          }}
          onClick={() => setShowTooltip(false)}
        />
      )}
    </div>
  )
}

export default InfoButton